import $ from 'jquery';

$(() => {
  const embeds = document.querySelectorAll('[data-resource-embed]');

  embeds.forEach((embed) => {
    const video = embed.querySelector('[data-resource-video]');
    const message = embed.querySelector('[data-resource-video-error]');
    if (!video || !message) {
      return;
    }

    const showError = () => {
      video.hidden = true;
      message.hidden = false;
      const $rail = $(embed).closest('[data-media-rail]');
      if ($rail.hasClass('slick-initialized')) {
        $rail.slick('setPosition');
      }
    };

    // Source failures do not bubble; capture them as well as playback errors.
    video.addEventListener('error', showError, true);
    // Loading can fail before the DOM-ready handler attaches the listener.
    if (video.error || video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) {
      showError();
    }
  });

  if (!embeds.length || !window.ResizeObserver) {
    return;
  }

  // Social embeds resize asynchronously. Keep the shared carousel in sync.
  const sizes = new WeakMap();
  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ target, contentRect }) => {
      const width = Math.round(contentRect.width);
      const height = Math.round(contentRect.height);
      const previous = sizes.get(target);

      if (previous && previous.width === width && previous.height === height) {
        return;
      }

      sizes.set(target, { width, height });
      const facebook = target.querySelector(
        'iframe[src*="facebook.com/plugins/"]'
      );

      if (facebook && width > 0 && (!previous || previous.width !== width)) {
        const url = new URL(facebook.src);
        if (url.searchParams.get('width') !== String(width)) {
          url.searchParams.set('width', String(width));
          facebook.src = url.toString();
        }
      }

      window.requestAnimationFrame(() => {
        const $rail = $(target).closest('[data-media-rail]');
        if ($rail.hasClass('slick-initialized')) {
          $rail.slick('setPosition');
        }
      });
    });
  });

  embeds.forEach((embed) => observer.observe(embed));
});
